<template>
  <div class="hrwork">
    <toptitle :title1="titlework" />
    <van-tabs v-model="activeTab" @change="switchTab" swipeable>
      <van-tab title="证明列表"> </van-tab>
      <van-tab title="提醒"></van-tab>
    </van-tabs>
    <div class="blank"></div>
    <van-list
      :finished="loadFinished"
      v-model="loading"
      @load="loadMore"
      finished-text="没有更多了"
    >
      <ListCert v-if="activeTab == 0" :subBody="subBodyCertNotPrint" :subBodyAll="subBodyCert" :subBodyPrinted="subBodyCertPrinted" :subBodyNotPrint="subBodyCertNotPrint" />
      <ListWarning v-if="activeTab == 1" :subBody="subBodyWarning" />
    </van-list>
  </div>
</template>

<script>
import toptitle from "../components/toptitle";

import { GetEmplWarningDataApi, GetCertPrintListApi } from "../request/api";

import dateformat from "@/utils/dateformat";

import ListWarning from "../components/hrwork/listwarning";
import ListCert from "../components/hrwork/listcert";

export default {
  data() {
    name: "hrwork";
    return {
      titlework: "HR工作台",
      activeTab: 0,
      loading: false,
      loadFinished: false,
      currentPageNo: 1,
      maxPageNo: 0,
      pageSize: "5000", ///每页数据条数
      subBodyWarning: [],
      subBodyCert: [],
      subBodyCertPrinted:[],
      subBodyCertNotPrint:[],
    };
  },
  methods: {
    switchTab() {
      //切换子页面，重新获取数据
      this.currentPageNo = 1;
      this.getList();
    },
    loadMore() {
      //加载下一页的数据
      this.currentPageNo++;
      if (this.currentPageNo > this.maxPageNo) {
        //已经加载到了最后一页
        this.loadFinished = true;
      } else {
        this.getList();
      }
    },
    getList() {
      this.loading = true;
      let params = null;
      let requestFunc = null;
      let emplID = sessionStorage.getItem("EMPLID");
      let actType = this.activeTab; //具体要执行的操作
      let rtnSuccessCode = null; //执行的操作完成后成功时的代码值
      //根据页面序号确定所需查询的数据类型
      switch (actType) {
        case 0:
          params = {
            params: {
              emplId: emplID,
              getpageNo: this.currentPageNo.toString(),
              pageRecords: this.pageSize, //每页获取数据条数
            },
          };
          requestFunc = GetCertPrintListApi;
          rtnSuccessCode = 200;
          break;
        case 1:
          params = {
            EMPLID: emplID,
            pageRecords: this.pageSize, //每页获取数据条数
            getPageNo: this.currentPageNo.toString(),
          };
          requestFunc = GetEmplWarningDataApi;
          rtnSuccessCode = 1;
          break;
      }
      requestFunc(params).then((res) => {
        this.loading = false;
        if (this.currentPageNo == 1) {
          //如果当前是第一页，清空相关数据
          this.subBodyWarning = [];
          this.subBodyCert = [];
        }
        //通过  concat 给数组添加元素，以支持多页数据
        switch (actType) {
          case 0:

            let rtnData = res.data;

            if (rtnData.code == rtnSuccessCode) {
              this.subBodyCert = this.subBodyCert.concat(rtnData.data);
              //根据页面返回值决定是否要显示加载已完成的提示
              //具体的页数需要计算
              this.maxPageNo = Math.ceil(
                parseInt(rtnData.totalSize) / parseFloat(this.pageSize)
              );

              //分解未打印和已打印的记录
              this.subBodyCertNotPrint = [];
              this.subBodyCertPrinted = [];
              for(let i = 0;i<this.subBodyCert.length;i++){
                
                let itemCert = this.subBodyCert[i];
                if(itemCert.printStatus === "N") this.subBodyCertNotPrint.push(itemCert);
                else this.subBodyCertPrinted.push(itemCert);
              }

              console.log(this.subBodyCertPrinted);
            }
            break;
          case 1:
            if (res.RESULTCODE == rtnSuccessCode) {
              let { header, subBody } = res.DATA;


              this.subBodyWarning = this.subBodyWarning.concat(subBody);

              //根据页面返回值决定是否要显示加载已完成的提示
              this.maxPageNo = parseInt(header.MaxPage);
            }

            break;
        }
        if (this.currentPageNo >= this.maxPageNo) {
          this.loadFinished = true;
        } else {
          this.loadFinished = false;
        }
      });
    },
  },
  components: {
    toptitle,

    ListWarning,
    ListCert,
  },
  filters: {
    datefmt(val) {
      //格式化日期查询条件的显示内容

      if (!val) return "";
      return dateformat("yyyy-MM-dd", new Date(val));
    },
    typefmt(val) {
      if (!val) return "";
      if (val.toLowerCase() === "onjob") return "在职证明";
      if (val.toLowerCase() === "income") return "收入证明";
    },
  },
  created() {
    this.getList();
  },
};
</script>
<style lang="less" scoped>
/deep/ .van-tabs__line {
  width: 104px;
  background: #733e2a;
}
/deep/ .van-tab--active {
  color: #733e2a;
  font-weight: bold;
}
.blank {
  width: 100%;
  height: 10px;
  border-bottom: 1px solid #e5e5e5;
}
.detail {
  padding: 0 16px;
  background: white;
  display: flex;
  border-bottom: 1px solid #e5e5e5;
  font-size: 15px;
  div {
    p {
      line-height: 30px;
    }
    .word {
      color: #999999;
      font-size: 13px;
    }
  }
  i {
    flex: 1;
    text-align: right;
    line-height: 60px;
  }
}
</style>